var map = {
	"./int_bo_desktop.png": 73826,
	"./int_bo_mobile.png": 48272,
	"./int_cl_desktop.png": 36692,
	"./int_cl_mobile.png": 28154,
	"./int_mx_desktop.png": 37005,
	"./int_mx_mobile.png": 95078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4553;